
import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
class ModalUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            fullname: '',
            address: '',
            roleid: '',
            region: '',
        }
        this.listenToEmitter();
    }
    listenToEmitter() {
        emitter.on('EVENT_CLEAR_MODAL_DATA', data => {
            this.setState({
                email: '',
                password: '',
                fullname: '',
                address: '',
                roleid: '',
                region: '',
            })
            console.log('emittet', data)
        });
    }
    componentDidMount() {
        // console.log('',)
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        console.log("copyState: ", copyState)
        console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = ['email', 'password', 'fullname', 'address'];
        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleAddNewUser = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.createNewUser(this.state)
        }


        console.log("data modal: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.isOpen);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-user-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Creating new user</ModalHeader>
                <ModalBody>
                    <div className='modal-user-body'>

                        <div className='input-container'>
                            <label>Email: </label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter email"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'email')
                                }}
                                value={this.state.email}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Password: </label>
                            <input
                                type="password"
                                name="password"
                                placeholder="Enter password"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'password')
                                }}
                                value={this.state.password}
                            />
                        </div>
                    </div>
                    <div className='modal-user-body'>
                        <div className='input-container'>
                            <label>Fullname: </label>
                            <input
                                type="fullname"
                                name="fullname"
                                placeholder="Enter fullname"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'fullname')
                                }}
                                value={this.state.fullname}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Address: </label>
                            <input
                                type="address"
                                name="address"
                                placeholder="Enter address"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'address')
                                }}
                                value={this.state.address}
                            />
                        </div>
                    </div>
                    <div className='modal-user-body'>
                        <div className='input-container'>
                            <label>Role: </label>
                            <input
                                type="roleid"
                                name="roleid"
                                placeholder="Enter role"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'roleid')
                                }}
                            />
                        </div>

                    </div>
                    <div className='modal-user-body'>
                        <div className='input-container max-width-input'>
                            <label>Region: </label>
                            <input
                                type="region"
                                name="region"
                                placeholder="Enter region"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'region')
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleAddNewUser}>Add New</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalUser);


